var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c("div", { staticClass: "mb-4" }, [
        _c(
          "div",
          {},
          [
            _c("div", { staticClass: "mb-2" }, [
              _c("div", { staticClass: "form-check" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.purchaseAsBusiness,
                      expression: "purchaseAsBusiness",
                    },
                  ],
                  staticClass: "form-check-input",
                  attrs: { type: "checkbox", id: "purchaseAsBusiness" },
                  domProps: {
                    checked: Array.isArray(_vm.purchaseAsBusiness)
                      ? _vm._i(_vm.purchaseAsBusiness, null) > -1
                      : _vm.purchaseAsBusiness,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.purchaseAsBusiness,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            (_vm.purchaseAsBusiness = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.purchaseAsBusiness = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.purchaseAsBusiness = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form-check-label",
                    attrs: { for: "purchaseAsBusiness" },
                  },
                  [
                    _c("small", [
                      _vm._v(
                        _vm._s(_vm._f("translate")("Purchase as business"))
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.type === "person" && !_vm.simplifiedCheckout
              ? [
                  _vm.isAuthenticated
                    ? _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("div", { staticClass: "mb-2" }, [
                            _c("label", { attrs: { for: "name" } }, [
                              _c("small", [
                                _vm._v(_vm._s(_vm._f("translate")("Name"))),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.name,
                                  expression: "name",
                                },
                              ],
                              key: "name",
                              staticClass: "form-control",
                              class: { "is-invalid": "name" in _vm.errors },
                              attrs: {
                                id: "name",
                                autocomplete: "off",
                                type: "text",
                              },
                              domProps: { value: _vm.name },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.name = $event.target.value
                                },
                              },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col" }, [
                          _c("div", { staticClass: "mb-2" }, [
                            _c("label", { attrs: { for: "last_name" } }, [
                              _c("small", [
                                _vm._v(
                                  _vm._s(_vm._f("translate")("Last name"))
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.last_name,
                                  expression: "last_name",
                                },
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": "last_name" in _vm.errors,
                              },
                              attrs: {
                                id: "last_name",
                                autocomplete: "off",
                                type: "text",
                              },
                              domProps: { value: _vm.last_name },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.last_name = $event.target.value
                                },
                              },
                            }),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.display_phone_field
                    ? _c("div", { staticClass: "mb-2" }, [
                        _c("label", { attrs: { for: "phone" } }, [
                          _c("small", [
                            _vm._v(_vm._s(_vm._f("translate")("Phone"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "###############",
                              expression: "'###############'",
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.phone,
                              expression: "phone",
                            },
                          ],
                          key: "phone",
                          staticClass: "form-control",
                          class: { "is-invalid": "phone" in _vm.errors },
                          attrs: {
                            id: "phone",
                            autocomplete: "off",
                            type: "text",
                          },
                          domProps: { value: _vm.phone },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.phone = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "small",
                          [_c("InputErrors", { attrs: { name: "phone" } })],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-2" }, [
                    _c("label", { attrs: { for: "address1" } }, [
                      _c("small", [
                        _vm._v(_vm._s(_vm._f("translate")("Address"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.address1,
                          expression: "address1",
                        },
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": "address1" in _vm.errors },
                      attrs: {
                        id: "address1",
                        autocomplete: "off",
                        type: "text",
                      },
                      domProps: { value: _vm.address1 },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.address1 = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _vm.student.type === "company" || _vm.student.vat_number
                    ? _c("div", { staticClass: "mb-2" }, [
                        _c("label", { attrs: { for: "address2" } }, [
                          _c("small", [
                            _vm._v(_vm._s(_vm._f("translate")("Address 2"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.address2,
                              expression: "address2",
                            },
                          ],
                          staticClass: "form-control",
                          class: { "is-invalid": "address2" in _vm.errors },
                          attrs: {
                            id: "address2",
                            autocomplete: "off",
                            type: "text",
                          },
                          domProps: { value: _vm.address2 },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.address2 = $event.target.value
                            },
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-5 col-lg-4" }, [
                      _c("div", { staticClass: "mb-2" }, [
                        _c("label", { attrs: { for: "postal_code" } }, [
                          _c("small", [
                            _vm._v(_vm._s(_vm._f("translate")("Postal code"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.postal_code,
                              expression: "postal_code",
                            },
                          ],
                          staticClass: "form-control",
                          class: { "is-invalid": "postal_code" in _vm.errors },
                          attrs: {
                            id: "postal_code",
                            autocomplete: "off",
                            type: "text",
                          },
                          domProps: { value: _vm.postal_code },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.postal_code = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "small",
                          [
                            _c("InputErrors", {
                              attrs: { name: "postal_code" },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-7 col-lg-8" }, [
                      _c("div", { staticClass: "mb-2" }, [
                        _c("label", { attrs: { for: "city" } }, [
                          _c("small", [
                            _vm._v(_vm._s(_vm._f("translate")("City"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.city,
                              expression: "city",
                            },
                          ],
                          staticClass: "form-control",
                          class: { "is-invalid": "city" in _vm.errors },
                          attrs: {
                            id: "city",
                            autocomplete: "off",
                            type: "text",
                          },
                          domProps: { value: _vm.city },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.city = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mb-2" },
                    [
                      _c("label", { attrs: { for: "country" } }, [
                        _c("small", [
                          _vm._v(_vm._s(_vm._f("translate")("Country"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("Select", {
                        class: { "is-invalid": "country" in _vm.errors },
                        attrs: {
                          inputId: "country",
                          autocomplete: "off",
                          reduce: (c) => c.code,
                          options: _vm.countries,
                          placeholder: _vm.$t("Choose country"),
                        },
                        model: {
                          value: _vm.country,
                          callback: function ($$v) {
                            _vm.country = $$v
                          },
                          expression: "country",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "company"
              ? [
                  _vm.display_phone_field
                    ? _c("div", { staticClass: "mb-2" }, [
                        _c("label", { attrs: { for: "phone" } }, [
                          _c("small", [
                            _vm._v(_vm._s(_vm._f("translate")("Phone"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "###############",
                              expression: "'###############'",
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.phone,
                              expression: "phone",
                            },
                          ],
                          key: "phone",
                          staticClass: "form-control",
                          class: { "is-invalid": "phone" in _vm.errors },
                          attrs: {
                            id: "phone",
                            autocomplete: "off",
                            type: "text",
                          },
                          domProps: { value: _vm.phone },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.phone = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "small",
                          [_c("InputErrors", { attrs: { name: "phone" } })],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-2" }, [
                    _c(
                      "label",
                      { staticClass: "small", attrs: { for: "vat_number" } },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("translate")("Vat number / Tax id")) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: "XXXX#####XXX###",
                            expression: "'XXXX#####XXX###'",
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.vat_number,
                            expression: "vat_number",
                          },
                        ],
                        key: "vat_number",
                        staticClass: "form-control",
                        class: { "is-invalid": "vat_number" in _vm.errors },
                        attrs: {
                          id: "vat_number",
                          autocomplete: "off",
                          type: "text",
                          placeholder: _vm.countryPlaceholder,
                        },
                        domProps: { value: _vm.vat_number },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.vat_number = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-dark px-4 fw-semibold",
                          attrs: { disabled: !_vm.showCheckByNip },
                          on: { click: _vm.checkByNip },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("translate")("Download")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.nipLookupState === "found"
                    ? [
                        _c("div", { staticClass: "mb-2" }, [
                          _c("label", { attrs: { for: "company_name" } }, [
                            _c("small", [
                              _vm._v(
                                _vm._s(_vm._f("translate")("Company name"))
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.company_name,
                                expression: "company_name",
                              },
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": "company_name" in _vm.errors,
                            },
                            attrs: {
                              id: "company_name",
                              autocomplete: "off",
                              type: "text",
                            },
                            domProps: { value: _vm.company_name },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.company_name = $event.target.value
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-2" }, [
                          _c("label", { attrs: { for: "address1" } }, [
                            _c("small", [
                              _vm._v(_vm._s(_vm._f("translate")("Address"))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.address1,
                                expression: "address1",
                              },
                            ],
                            staticClass: "form-control",
                            class: { "is-invalid": "address1" in _vm.errors },
                            attrs: {
                              id: "address1",
                              autocomplete: "off",
                              type: "text",
                            },
                            domProps: { value: _vm.address1 },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.address1 = $event.target.value
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-5 col-lg-4" }, [
                            _c("div", { staticClass: "mb-2" }, [
                              _c("label", { attrs: { for: "postal_code" } }, [
                                _c("small", [
                                  _vm._v(
                                    _vm._s(_vm._f("translate")("Postal code"))
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.postal_code,
                                    expression: "postal_code",
                                  },
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": "postal_code" in _vm.errors,
                                },
                                attrs: {
                                  id: "postal_code",
                                  autocomplete: "off",
                                  type: "text",
                                },
                                domProps: { value: _vm.postal_code },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.postal_code = $event.target.value
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "small",
                                [
                                  _c("InputErrors", {
                                    attrs: { name: "postal_code" },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-7 col-lg-8" }, [
                            _c("div", { staticClass: "mb-2" }, [
                              _c("label", { attrs: { for: "city" } }, [
                                _c("small", [
                                  _vm._v(_vm._s(_vm._f("translate")("City"))),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.city,
                                    expression: "city",
                                  },
                                ],
                                staticClass: "form-control",
                                class: { "is-invalid": "city" in _vm.errors },
                                attrs: {
                                  id: "city",
                                  autocomplete: "off",
                                  type: "text",
                                },
                                domProps: { value: _vm.city },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.city = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mb-2" },
                          [
                            _c("label", { attrs: { for: "country" } }, [
                              _c("small", [
                                _vm._v(_vm._s(_vm._f("translate")("Country"))),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("Select", {
                              class: { "is-invalid": "country" in _vm.errors },
                              attrs: {
                                inputId: "country",
                                autocomplete: "off",
                                reduce: (c) => c.code,
                                options: _vm.countries,
                                placeholder: _vm.$t("Choose country"),
                              },
                              model: {
                                value: _vm.country,
                                callback: function ($$v) {
                                  _vm.country = $$v
                                },
                                expression: "country",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.nipLookupState === "not_found"
                    ? [
                        _c("div", { staticClass: "small text-danger mb-2" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm._f("translate")(
                                  "Not found. Please enter the information manually."
                                )
                              ) +
                              "\n        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-2" }, [
                          _c("label", { attrs: { for: "company_name" } }, [
                            _c("small", [
                              _vm._v(
                                _vm._s(_vm._f("translate")("Company name"))
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.company_name,
                                expression: "company_name",
                              },
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": "company_name" in _vm.errors,
                            },
                            attrs: {
                              id: "company_name",
                              autocomplete: "off",
                              type: "text",
                            },
                            domProps: { value: _vm.company_name },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.company_name = $event.target.value
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-2" }, [
                          _c("label", { attrs: { for: "address1" } }, [
                            _c("small", [
                              _vm._v(_vm._s(_vm._f("translate")("Address"))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.address1,
                                expression: "address1",
                              },
                            ],
                            staticClass: "form-control",
                            class: { "is-invalid": "address1" in _vm.errors },
                            attrs: {
                              id: "address1",
                              autocomplete: "off",
                              type: "text",
                            },
                            domProps: { value: _vm.address1 },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.address1 = $event.target.value
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-2" }, [
                          _c("label", { attrs: { for: "address2" } }, [
                            _c("small", [
                              _vm._v(_vm._s(_vm._f("translate")("Address 2"))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.address2,
                                expression: "address2",
                              },
                            ],
                            staticClass: "form-control",
                            class: { "is-invalid": "address2" in _vm.errors },
                            attrs: {
                              id: "address2",
                              autocomplete: "off",
                              type: "text",
                            },
                            domProps: { value: _vm.address2 },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.address2 = $event.target.value
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-5 col-lg-4" }, [
                            _c("div", { staticClass: "mb-2" }, [
                              _c("label", { attrs: { for: "postal_code" } }, [
                                _c("small", [
                                  _vm._v(
                                    _vm._s(_vm._f("translate")("Postal code"))
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.postal_code,
                                    expression: "postal_code",
                                  },
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": "postal_code" in _vm.errors,
                                },
                                attrs: {
                                  id: "postal_code",
                                  autocomplete: "off",
                                  type: "text",
                                },
                                domProps: { value: _vm.postal_code },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.postal_code = $event.target.value
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "small",
                                [
                                  _c("InputErrors", {
                                    attrs: { name: "postal_code" },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-7 col-lg-8" }, [
                            _c("div", { staticClass: "mb-2" }, [
                              _c("label", { attrs: { for: "city" } }, [
                                _c("small", [
                                  _vm._v(_vm._s(_vm._f("translate")("City"))),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.city,
                                    expression: "city",
                                  },
                                ],
                                staticClass: "form-control",
                                class: { "is-invalid": "city" in _vm.errors },
                                attrs: {
                                  id: "city",
                                  autocomplete: "off",
                                  type: "text",
                                },
                                domProps: { value: _vm.city },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.city = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mb-2" },
                          [
                            _c("label", { attrs: { for: "country" } }, [
                              _c("small", [
                                _vm._v(_vm._s(_vm._f("translate")("Country"))),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("Select", {
                              class: { "is-invalid": "country" in _vm.errors },
                              attrs: {
                                inputId: "country",
                                autocomplete: "off",
                                reduce: (c) => c.code,
                                options: _vm.countries,
                                placeholder: _vm.$t("Choose country"),
                              },
                              model: {
                                value: _vm.country,
                                callback: function ($$v) {
                                  _vm.country = $$v
                                },
                                expression: "country",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ]
              : _vm._e(),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }